var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect2, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelVehicle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 488,
    height: 176,
    viewBox: "0 0 488 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 488,
    height: 176,
    rx: 4,
    fill: "black",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.5 149C192.299 149 197 144.299 197 138.5C197 132.701 192.299 128 186.5 128C186.332 128 186.166 128.004 186 128.012C181.285 128.233 177.383 131.564 176.299 136C176.104 136.801 176 137.638 176 138.5C176 144.299 180.701 149 186.5 149ZM186.5 144C189.538 144 192 141.538 192 138.5C192 135.462 189.538 133 186.5 133C183.462 133 181 135.462 181 138.5C181 141.538 183.462 144 186.5 144Z",
    fill: "#4B3F4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192 138.5C192 141.538 189.538 144 186.5 144C183.462 144 181 141.538 181 138.5C181 135.462 183.462 133 186.5 133C189.538 133 192 135.462 192 138.5Z",
    fill: "#6F6571"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M197.5 128H186.5C192.299 128 197 132.701 197 138.5H267C267 132.701 271.701 128 277.5 128H197.5Z",
    fill: "#6F6571"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M159 128V133C159 134.657 160.343 136 162 136H176.299C177.383 131.564 181.285 128.233 186 128.012V128H159Z",
    fill: "#C9C6CA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M197.5 117V128H277.5H299.5H321.5H326.5C328.157 128 329.5 126.657 329.5 125V117H197.5Z",
    fill: "#D2890A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M326.5 61H200.5C198.843 61 197.5 62.3431 197.5 64V80V117H329.5V64C329.5 62.3431 328.157 61 326.5 61Z",
    fill: "#E19C22"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M169.167 89L165.247 100.76C164.983 101.551 164.622 102.303 164.175 103H184.5C185.605 103 186.5 102.105 186.5 101V91C186.5 89.8954 185.605 89 184.5 89H169.167Z",
    fill: "#5D5360"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M171 83.5L169.167 89H184.5C185.605 89 186.5 89.8954 186.5 91V101C186.5 102.105 185.605 103 184.5 103H190C191.105 103 192 102.105 192 101V85.5C192 84.3954 191.105 83.5 190 83.5H171Z",
    fill: "#C9C6CA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M165 114H159V122H165C166.105 122 167 121.105 167 120V116C167 114.895 166.105 114 165 114Z",
    fill: "#F9E399"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M195.5 78H169.75C168.231 78 167 79.2312 167 80.75C167 82.2688 168.231 83.5 169.75 83.5H171H190C191.105 83.5 192 84.3954 192 85.5V101C192 102.105 191.105 103 190 103H184.5H164.175C163.789 103.601 163.339 104.161 162.831 104.669L160.464 107.036C159.527 107.973 159 109.245 159 110.571V114H165C166.105 114 167 114.895 167 116V120C167 121.105 166.105 122 165 122H159V128H186H186.5H197.5V117V80C197.5 78.8954 196.605 78 195.5 78Z",
    fill: "#DBD9DC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.5 149C305.299 149 310 144.299 310 138.5C310 132.701 305.299 128 299.5 128C293.701 128 289 132.701 289 138.5C289 144.299 293.701 149 299.5 149ZM299.5 144C302.538 144 305 141.538 305 138.5C305 135.462 302.538 133 299.5 133C296.462 133 294 135.462 294 138.5C294 141.538 296.462 144 299.5 144Z",
    fill: "#4B3F4E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M305 138.5C305 141.538 302.538 144 299.5 144C296.462 144 294 141.538 294 138.5C294 135.462 296.462 133 299.5 133C302.538 133 305 135.462 305 138.5Z",
    fill: "#6F6571"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M283 138.5C283 141.538 280.538 144 277.5 144C274.462 144 272 141.538 272 138.5C272 135.462 274.462 133 277.5 133C280.538 133 283 135.462 283 138.5Z",
    fill: "#6F6571"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.5 149C283.299 149 288 144.299 288 138.5C288 132.701 283.299 128 277.5 128C271.701 128 267 132.701 267 138.5C267 144.299 271.701 149 277.5 149ZM277.5 144C280.538 144 283 141.538 283 138.5C283 135.462 280.538 133 277.5 133C274.462 133 272 135.462 272 138.5C272 141.538 274.462 144 277.5 144Z",
    fill: "#4B3F4E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M299.5 128H277.5C283.299 128 288 132.701 288 138.5H289C289 132.701 293.701 128 299.5 128Z",
    fill: "#6F6571"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M321.5 128H299.5C305.299 128 310 132.701 310 138.5H318.5C320.157 138.5 321.5 137.157 321.5 135.5V128Z",
    fill: "#6F6571"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 311,
    y: 34,
    width: 49,
    height: 49,
    rx: 7,
    fill: "#C93131"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M340.743 47.9021C341.945 46.6993 343.895 46.6993 345.098 47.9021C346.301 49.105 346.301 51.0548 345.098 52.2576L339.568 57.7879C339.45 57.9051 339.45 58.095 339.568 58.2122L345.098 63.7426C346.301 64.9454 346.301 66.8952 345.098 68.098C343.895 69.3008 341.945 69.3006 340.743 68.098L335.212 62.5676C335.095 62.4505 334.905 62.4505 334.788 62.5676L329.258 68.098C328.055 69.3008 326.105 69.3006 324.902 68.098C323.699 66.8951 323.699 64.9454 324.902 63.7426L330.432 58.2122C330.55 58.095 330.55 57.9051 330.432 57.7879L324.902 52.2576C323.699 51.0547 323.699 49.105 324.902 47.9021C326.105 46.6993 328.055 46.6993 329.258 47.9021L334.788 53.4325C334.905 53.5497 335.095 53.5497 335.212 53.4325L340.743 47.9021Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelVehicle);
export default __webpack_public_path__ + "static/media/cancelVehicle.95d39f7322575a849c6d086d7aa0e82a.svg";
export { ForwardRef as ReactComponent };